import { Component } from "@angular/core";

@Component({
  selector: "app-how-it-works-section",
  templateUrl: "./how-it-works-section.component.html",
  styleUrls: ["./how-it-works-section.component.scss"],
})
export class HowItWorksSectionComponent {
  readonly steps = [
    {
      number: 1,
      titleKey: "UX_TEXT.HOW_IT_WORKS.STEP_1_TITLE",
      descriptionKey: "UX_TEXT.HOW_IT_WORKS.STEP_1_DESC",
      color: "#1d5d9b",
    },
    {
      number: 2,
      titleKey: "UX_TEXT.HOW_IT_WORKS.STEP_2_TITLE",
      descriptionKey: "UX_TEXT.HOW_IT_WORKS.STEP_2_DESC",
      color: "#75c2f6",
    },
    {
      number: 3,
      titleKey: "UX_TEXT.HOW_IT_WORKS.STEP_3_TITLE",
      descriptionKey: "UX_TEXT.HOW_IT_WORKS.STEP_3_DESC",
      color: "#f2c525",
      darkText: true,
    },
  ];
}
